<template>
    <div class="cell-renderer-dropdown-list cell-renderer-dropdown-list-wrapper">
      <div v-if="dropdownOptions.length" class="dropdown-buttons">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            :style="wrapperStyle"
            class="cell-renderer-download-border icon-wrapper"
          >
            <font-awesome-icon class="download-icon" :icon="['fal', 'copy']" />
            <span style="margin-left:5px;">{{ $t('PolicyDocuments') }}</span>
          </div>

          <vs-dropdown-menu class="dropdown-list-buttons-wrapper cursor-pointer">
            <vs-dropdown-item v-for="(item, index) in dropdownOptions" :key="index">
              <span class="option" @click="clicked(item)">
                <font-awesome-icon class="download-icon" :icon="[item.iconType, item.icon]" />
                <span>{{ item.displayName }}</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
</template>

<script>
export default {
  name: 'CellRendererDropdownList',
  computed: {
    dropdownOptions () {
      return this.params.dropdownOptions || '';
    },
    wrapperStyle() {
      return {
        color: '#7B61FF',
        backgroundColor: this.hexToRgba('#7B61FF', 0.1),
        border: '1px solid #7B61FF',
        fontSize: '10px',
        width: 'max-content'
      };
    }
  },
  methods: {
    clicked(item) {
      if (!item.field) {
        return;
      }

      const params = {
        documentType: item.documentType,
        documentGuid: [this.params.data[item.field]],
        documentTypeId: item.documentTypeId,
        CommercialProductPK: this.params.data.ID,
      };

      this.$parent.$emit('download', params);
    },
    hexToRgba(hex, alpha) {
      let r = 0, g = 0, b = 0;
      if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
      } else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
      }
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  },
}
</script>

<style lang="scss">
  @import '@/assets/scss/custom/components/variables';
  .cell-renderer-dropdown-list.cell-renderer-dropdown-list-wrapper {
    // width: 100%;

    .cell-renderer-download-border {
      &.icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 15px;
        padding: 8.5px 8px;
      }
        
      &.disabled {
        opacity: 0.5;
      }
    }
  }

  .dropdown-list-buttons-wrapper {
    width: max-content;

    .option {
      display: grid;
      grid-template-columns: 24px 1fr; // 24px for icon, adjust as needed
      align-items: center;
      gap: 8px;

      .download-icon {
        width: 24px;
        min-width: 24px;
        max-width: 24px;
        text-align: center;
        display: flex;
        justify-content: center;
      }
    }
  }
</style>
